import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

const createClientTagLinkGQL = ({ tagIds, clientId }) => {
  const query = `
   mutation createTagLink($input: CreateTagLinksInput!){
    createTagLink(input: $input){
        id
        tagId
        payload{
            clientId
        }
    }
}
  `

  const creatingTags = tagIds.map(tagId => ({
    tagId,
    payload: {
      clientId,
    },
  }))

  const params = {
    input: {
      tags: creatingTags,
    },
  }
  return callAuthorizedGraphQLEndpoint(query, params)
}

const deleteClientTagLinkGQL = ({ tagLinkIds }) => {
  const query = `
   mutation deleteTagLink($input: DeleteTagLinksInput!){
      deleteTagLink(input: $input){
          deletedIds{
            id
          }
     }
  }
  `
  const params = {
    input: { tagLinkIds },
  }
  return callAuthorizedGraphQLEndpoint(query, params)
}

export { createClientTagLinkGQL, deleteClientTagLinkGQL }



// WEBPACK FOOTER //
// ./src/Containers/Clients/gql.js